export default __webpack_public_path__ + "static/media/gallery-wip-emitter_05.67a81682.jpg";